import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker'
// import './init'
import router from './router';
import store from './store';
import axiosInstance from '@/common/axios';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// import '@/assets/styles/common/index.scss';
import '@/common/installVant';

import '@/common/infoCollect';

// 引入kdesign部分组件
// import '@/common/kdesign';

// 引入kdesign
import '@kdocs/kdesign-theme/default.css'; // KDesign 需要和主题搭配使用
import KDesignVue from '@kdocs/kdesign-vue';
import '@kdocs/kdesign-vue/lib/theme-chalk/index.css';
Vue.use(KDesignVue);

Vue.config.productionTip = false;
Vue.prototype.$http = axiosInstance;
Vue.use(Antd);

Vue.prototype.$eventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
